export default "__VITE_ASSET__BvUwDegt__"